import { GridCellProps } from '@progress/kendo-react-grid';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import { useContextSelector } from 'use-context-selector';
import { SearchProductDetailsContext } from '../SearchProductDetailsContext';

const SearchDescriptionCell = (props: GridCellProps) => {
  const { value } = useGridCellDisplayValue(props);

  const handleViewProductDetails = useContextSelector(
    SearchProductDetailsContext,
    (state) => state.handleViewProductDetails
  );
  const isFetchingProductDetails = useContextSelector(
    SearchProductDetailsContext,
    (state) => state.isFetchingProductDetails
  );
  const loadingProductDetails = useContextSelector(
    SearchProductDetailsContext,
    (state) => state.loadingProductDetails
  );
  const isDisabled = loadingProductDetails || isFetchingProductDetails;

  return (
    <GridCellBase {...props} rowSelectionEnabled={false} className="!p-0" title={value}>
      <button
        type="button"
        disabled={isDisabled}
        className="text-[#0E80B4] hover:underline focus:outline-2 focus:outline-black rounded text-left truncate w-[100%]"
        onClick={(e) => handleViewProductDetails(e, props.dataItem)}
      >
        {value}
      </button>
    </GridCellBase>
  );
};

export default SearchDescriptionCell;
